export type NotificationType = "warning" | "success" | "error" | "info"

const NOTIFICATION_TYPES: NotificationType[] = [
  "warning",
  "success",
  "error",
  "info",
]

export function normalizeNotificationType(value: unknown): NotificationType {
  if (
    typeof value === "string" &&
    NOTIFICATION_TYPES.includes(value as NotificationType)
  ) {
    return value as NotificationType
  }
  return "warning"
}

/** Raw shape stored in session/state. type is not normalized (can be backend enum). */
export interface AppNotification {
  id: string
  type: string
  title: string
  description?: string
  read: boolean
  createdAt: number
  /** Raw payload from backend/FCM - stored as-is. */
  data?: Record<string, unknown>
  /** Full Firebase message stringified (for debugging / replay). */
  rawPayload?: string
}
